<script lang="ts">
	import happyGuyImage from "@assets/images/happy-guy.jpg?webp&w=572&imagetools";
	import Disclosure from "@components/common/Disclosure.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./FaqSection.translations.json" with { type: "json" };

	const translate = getTranslate(translations);

	const faqs = [
		{
			question: translate("whyFathersFamilyQuestion"),
			answer: translate("whyFathersFamilyAnswer"),
		},
		{
			question: translate("howToJoinFathersFamilyQuestion"),
			answer: translate("howToJoinFathersFamilyAnswer"),
		},
		{
			question: translate("howToGetDiscountQuestion"),
			answer: translate("howToGetDiscountAnswer"),
		},
		{
			question: translate("whatWillIGetQuestion"),
			answer: translate("whatWillIGetAnswer"),
		},
		{
			question: translate("howToUnsubscribeQuestion"),
			answer: translate("howToUnsubscribeAnswer"),
		},
	];
</script>

<section
	class="full-width grid-container bg-fcrbeige py-10 sm:py-15 md:py-20 lg:pt-25 lg:pb-5 xl:pt-30 xl:pb-10 2xl:pt-40 2xl:pb-20 gap-y-10 sm:gap-y-15 md:gap-y-20 lg:gap-y-25 xl:gap-y-30 2xl:gap-y-40"
>
	<div class="container-8 xl:container-start-7 xl:container-end-12">
		<Heading level={2} text={translate("faqTitle")} class="heading-2 text-fcrdarkgray text-center xl:text-left mb-18" />
		<div class="md:min-h-100">
			{#each faqs as faq, i (i)}
				<Disclosure title={faq.question} group="faq">
					<Formatted text={faq.answer} />
				</Disclosure>
			{/each}
		</div>
	</div>
	<div class="xl:order-first xl:container-start-1 xl:container-end-6 flex items-start justify-center xl:h-full">
		<Media source={{ src: happyGuyImage, type: "image/webp" }} width={572} height={380} sourcesets={{}} alt="" />
	</div>
</section>
